import React, { useContext, useEffect, useState } from "react";
import { httpGet } from "../../components/helpers/httpMethods";
import { PaymentContext } from "../../context/paymentContext";
import "./renewSheet.css";

// One tap from a reminder email or the Subscriptions tab: shows the price the server worked out, then the usual Paystack window.
const PLAN = { weekly: "Weekly", monthly: "Monthly", quarterly: "Every 3 months", biannually: "Every 6 months", annually: "Yearly" };
const naira = (n) => `₦${Math.round(Number(n) || 0).toLocaleString("en-NG")}`;
const longDay = (d) => new Date(d).toLocaleDateString("en-GB", { timeZone: "Africa/Lagos", weekday: "long", day: "numeric", month: "long", year: "numeric" });

export default function RenewSheet({ subId, onClose }) {
  const pay = useContext(PaymentContext);
  const [q, setQ] = useState(null);
  const [error, setError] = useState("");
  useEffect(() => {
    httpGet(`me/renew/${subId}`).then((r) => {
      if (r && r.data && r.data.id) setQ(r.data);
      else setError((r && r.message) || "We couldn’t find this plan.");
    });
  }, [subId]);
  useEffect(() => {
    const k = (e) => e.key === "Escape" && onClose();
    window.addEventListener("keydown", k);
    return () => window.removeEventListener("keydown", k);
  }, [onClose]);
  const future = q && q.endsOn && new Date(q.endsOn) > new Date();
  const start = () => {
    onClose();
    pay.HandlePayWithMonifyFun({
      amount: q.price, subscriptionType: q.plan, currency: "NGN", publicationId: q.publicationId, isPaid: true,
      firstName: q.firstName, lastName: q.lastName, email: q.email, type: "CARD", renewOf: q.id,
    });
  };
  return (
    <div className="rw-wrap" role="dialog" aria-modal="true" aria-label="Renew your plan">
      <button type="button" className="rw-scrim" aria-label="Close" onClick={onClose} />
      <div className="rw-sheet">
        {error ? (
          <>
            <h2>Renew your plan</h2>
            <p>{error}</p>
            <button type="button" className="rw-pay" onClick={onClose}>Close</button>
          </>
        ) : !q ? <p>Loading…</p> : (
          <>
            <p className="rw-eyebrow">Renew your plan</p>
            <h2>{q.paper}</h2>
            <p className="rw-line"><span>{PLAN[q.plan] || q.plan}</span><b>{naira(q.price)}</b></p>
            {q.can ? (
              <>
                <p className="rw-note">{future ? `Your plan ends on ${longDay(q.endsOn)}. Your new period starts then, so you won’t lose any days.` : "Your new period starts as soon as you pay."}</p>
                <button type="button" className="rw-pay" onClick={start}>Pay {naira(q.price)}</button>
              </>
            ) : <p className="rw-note">{q.reason}</p>}
            <button type="button" className="rw-later" onClick={onClose}>{q.can ? "Not now" : "Close"}</button>
          </>
        )}
      </div>
    </div>
  );
}
